export enum PythonLoggingLevels {
    CRITICAL = '#d64d3c',
    ERROR = '#fc6256',
    WARNING = '#c19c00',
    INFO = '#13a10e',
    DEBUG = '#cccccc',
    NOTSET = '#cccccc',
}